<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <!-- 진행단계 -->
          <c-select
            type="search"
            codeGroupCd="VENDOR_ATTACH_TYPE_CD"
            itemText="codeName"
            itemValue="code"
            name="vendorAttachTypeCd"
            label="첨부분류"
            v-model="searchParam.vendorAttachTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-vendor type="search" label="업체" name="vendorCd" v-model="searchParam.vendorCd" />
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <!-- 기간(등록일) -->
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            defaultEnd="6M"
            :isToyear="true"
            label="기간(등록일)"
            name="period"
            v-model="searchParam.period"
          />
        </div>
        <div class="col-2">
          <c-field
            type="user" 
            label="담당자"
            name="regUserId"
            v-model="searchParam.regUserId" />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="도급업체별 관련서류 목록"
      tableId="table"
      :columns="grid.columns"
      :data="grid.data"
      :editable="editable"
      checkDisableColumn="rowDisabledFlag"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group>
          <c-btn label="등록" v-if="editable" :editable="editable" icon="add" @btnClicked="linkClick()" />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'vendor-attach',
  data() {
    return {
      searchParam: {
        vendorCd: null,
        regUserId: null,
        period: [],
      },
      vendorEvaluationKindCdItem: [],
      grid: {
        columns: [
          {
            name: 'vendorName',
            field: 'vendorName',
            label: '도급업체',
            style: 'width:100px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'title',
            field: 'title',
            label: '제목',
            style: 'width:200px',
            align: 'left',
            type: 'link',
            sortable: true,
          },
          {
            name: 'approvalStatusName',
            field: 'approvalStatusName',
            label: '결재진행단계',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'transmissionFlagName',
            field: 'transmissionFlagName',
            label: '전달여부',
            align: 'center',
            sortable: true,
            style: 'width:80px',
          },
          {
            name: 'regUserName',
            field: 'regUserName',
            label: '담당자',
            style: 'width:100px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'regDtStr',
            field: 'regDtStr',
            label: '등록일',
            style: 'width:100px',
            align: 'center',
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      typeUrl: '',
      popupOptions: {
        target: null,
        title: '',
        isFull: false,
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.mdm.cim.vendor.attach.list.url;

      this.searchParam.regUserId = this.$store.getters.user.userId
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.popupOptions.title = "도급업체별 관련서류 상세"; 
      this.popupOptions.param = {
        mdmVendorAttachId: row ? row.mdmVendorAttachId : '',
      };
      this.popupOptions.target = () => import(`${"./vendorAttachDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.width = '80%';
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
